import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router";

/** Lista-szűrők az URL-ben: megosztható/visszaléphető állapot (a fejezet-oldal
 *  „Mind (n)" linkjei is ezt használják). */
export function useFilters<T extends Record<string, string>>(defaults: T) {
  const [params, setParams] = useSearchParams();

  const values = useMemo(() => {
    const out = { ...defaults };
    for (const key of Object.keys(defaults) as Array<keyof T>) {
      const v = params.get(String(key));
      if (v !== null) out[key] = v as T[keyof T];
    }
    return out;
  }, [params, defaults]);

  const set = useCallback(
    (patch: Partial<Record<keyof T, string>>) => {
      const next = new URLSearchParams(params);
      for (const [key, value] of Object.entries(patch)) {
        if (!value) next.delete(key);
        else next.set(key, value);
      }
      if (!("page" in patch)) next.delete("page");
      setParams(next, { replace: true });
    },
    [params, setParams],
  );

  return { values, set };
}

export const num = (v: string): number | undefined => (v ? Number(v) : undefined);
